import type { LogicConfig, LogicResult } from '../types';
import type { QuestionValue } from '@lib/types/survey';
import type { ResultLogicConfig } from '../../components/screens/ResultsScreen';

/**
 * Process result logic configuration
 * @param config The result logic configuration
 * @param value The current question value (selected option key)
 */
export async function processResultLogic(
  config: LogicConfig,
  value: QuestionValue
): Promise<LogicResult> {
  // If no value is selected, return standard progression
  if (!value) {
    return {
      success: true,
      nextAction: {
        type: 'standard',
        value: 0
      }
    };
  }

  // Find the result logic configuration
  const resultLogicConfig = config as { config: ResultLogicConfig };
  if (!resultLogicConfig?.config?.correctAnswer) {
    return {
      success: true,
      nextAction: {
        type: 'standard',
        value: 0
      }
    };
  }

  // Check if response is correct
  const isCorrect = value === resultLogicConfig.config.correctAnswer;

  return {
    success: true,
    nextAction: {
      type: 'show_result',
      value: 0,
      metadata: {
        result: isCorrect ? 'correct' : 'incorrect',
        shouldContinueNavigation: false
      }
    }
  };
} 